import { FC } from 'react'

const CircleX: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '28'}
      height={height || '28'}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.1582 15.5084C17.6144 15.9646 17.6144 16.7019 17.1582 17.1581C16.9307 17.3856 16.632 17.4999 16.3334 17.4999C16.0347 17.4999 15.736 17.3856 15.5085 17.1581L14 15.6496L12.4915 17.1581C12.264 17.3856 11.9654 17.4999 11.6667 17.4999C11.368 17.4999 11.0694 17.3856 10.8419 17.1581C10.3857 16.7019 10.3857 15.9646 10.8419 15.5084L12.3504 13.9999L10.8419 12.4914C10.3857 12.0352 10.3857 11.2979 10.8419 10.8417C11.298 10.3856 12.0354 10.3856 12.4915 10.8417L14 12.3502L15.5085 10.8417C15.9647 10.3856 16.702 10.3856 17.1582 10.8417C17.6144 11.2979 17.6144 12.0352 17.1582 12.4914L15.6497 13.9999L17.1582 15.5084ZM14 2.33322C7.56704 2.33322 2.33337 7.56689 2.33337 13.9999C2.33337 20.4329 7.56704 25.6666 14 25.6666C20.433 25.6666 25.6667 20.4329 25.6667 13.9999C25.6667 7.56689 20.433 2.33322 14 2.33322Z'
        fill={fill || '#EF4D56'}
      />
    </svg>
  )
}

export default CircleX
